module.exports = __webpack_public_path__ + "static/media/file-chart-pie.800f7a88.svg";